/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useSize } from "../hooks/useTamanio";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ProyeccionDiariaBitacora } from "./Proyeccion.Bitacora";
import { useProyeccionDiaria } from "../hooks/useProyeccionDiaria";
import Swal from "sweetalert2";
import axios from "axios";

export const ProyeccionDiariaTable = ({
  id_cultivo,
  data,
  setData,
  fecha,
  onReload,
}) => {
  const { getSize } = useSize();
  const { deleteProyeccion } = useProyeccionDiaria();
  const [sizeList, setSizeList] = useState([]);
  const [selectedVariedad, setSelectedVariedad] = useState(null);

  const handleClose = () => {
    setSelectedVariedad(null);
  };

  const deletePoryeccionDiaria = async (id) => {
    Swal.fire({
      icon: "warning",
      title: "¿Está seguro que desea eliminar la proyección?",
      text: "Las proyecciones eliminadas no se podran recuperar",
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
      showLoaderOnConfirm: true,
      backdrop: true,
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: async () => {
        try {
          await deleteProyeccion(id);
        } catch (error) {
          let msg = ``;
          if (axios.isAxiosError(error)) {
            if (error.response.status === 400) {
              msg = `- ${error.response.data.msg}`;
            }
          }
          Swal.showValidationMessage(`
              Algo salio mal ${msg}
            `);
        }
      },
    }).then((res) => {
      if (res.isConfirmed) {
        Swal.fire({
          icon: "success",
          title: "Registro eliminado",
          timer: 1500,
        });
        onReload();
      }
    });
  };

  const handleSizeValueChange = (data_index, size, value) => {
    let porcentaje = Number(value);
    const proyeccion = [...data];
    const size_index = proyeccion[data_index].tamanios.findIndex(
      (item) => item.tamanio === size
    );
    const porcentaje_total = proyeccion[data_index].tamanios
      .filter((item) => item.tamanio !== size)
      .reduce((sum, item) => sum + Number(item.porcentaje), 0);

    if (porcentaje_total + Number(value) > 100) {
      porcentaje = "";
    }
    if (size_index > -1) {
      proyeccion[data_index].tamanios[size_index].porcentaje = porcentaje;
    } else {
      proyeccion[data_index].tamanios.push({
        tamanio: size,
        porcentaje: porcentaje,
      });
    }
    setData([...proyeccion]);
  };

  const handleTotalValueChange = (data_index, value) => {
    const proyeccion = [...data];
    proyeccion[data_index].total = value;
    setData(proyeccion);
  };

  useEffect(() => {
    const getTamanio = async () => {
      const response = await getSize(id_cultivo);
      setSizeList(response);
    };
    if (id_cultivo !== "") {
      getTamanio();
    }
  }, [id_cultivo]);

  return (
    <>
      <div className="row">
        <div className="col-12 table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Variedad</th>
                {/* <th>Prod./Ha.</th> */}
                <th>Total</th>
                {sizeList?.map((item) => (
                  <th key={item.tamano}>{`%${item.tamano}`}</th>
                ))}
                <th>
                  {data?.reduce((sum, item) => sum + Number(item.total), 0)}
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {data?.map((item, index) => (
                <tr key={item.id_variedad}>
                  <td>{item.variedad}</td>
                  {/* <td>{Number(item.produccion_hectarea).toFixed(0)}</td> */}
                  <td style={{ minWidth: "120px" }}>
                    <input
                      className="form-control"
                      type="number"
                      onFocus={blurOnWheel}
                      min={0}
                      onChange={(e) =>
                        handleTotalValueChange(index, e.target.value)
                      }
                      value={item.total}
                    />
                  </td>
                  {sizeList?.map((size) => (
                    <td key={size.tamano} style={{ minWidth: "80px" }}>
                      <input
                        onChange={(e) =>
                          handleSizeValueChange(
                            index,
                            size.tamano,
                            e.target.value
                          )
                        }
                        className="form-control"
                        type="number"
                        onFocus={blurOnWheel}
                        min={0}
                        value={
                          item.tamanios.find(
                            (tam) => tam.tamanio === size.tamano
                          )?.porcentaje ?? ""
                        }
                      />
                      <label>
                        {renderTotalSize(
                          Number(
                            item.tamanios.find(
                              (tam) => tam.tamanio === size.tamano
                            )?.porcentaje ?? ""
                          ),
                          Number(item.total)
                        )}
                      </label>
                    </td>
                  ))}
                  <td>
                    {item.tamanios.reduce(
                      (sum, size) => sum + Number(size.porcentaje),
                      0
                    )}
                    %
                  </td>
                  <td>
                    <button
                      className="btn btn-outline-dark"
                      onClick={() => setSelectedVariedad(item.id_variedad)}
                    >
                      <FontAwesomeIcon icon="fas fa-book" />
                    </button>
                    {item.id ? (
                      <button
                        className="btn btn-outline-danger"
                        onClick={() => deletePoryeccionDiaria(item.id)}
                      >
                        <FontAwesomeIcon icon="far fa-trash-alt" />
                      </button>
                    ) : null}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <ProyeccionDiariaBitacora
        isVisible={selectedVariedad !== null}
        toggle={handleClose}
        fecha={fecha}
        variedad={
          data.find((item) => item.id_variedad === selectedVariedad)
            ?.variedad ?? ""
        }
        id_variedad={selectedVariedad}
      />
    </>
  );
};

const blurOnWheel = (e) => {
  e.target.addEventListener("wheel", (event) => {
    if (event.target) {
      event.target.blur();
    }
  });
};

const renderTotalSize = (size_value, prod_ha) => {
  if (prod_ha && size_value) {
    return Math.round(prod_ha * (size_value / 100));
  }

  return 0;
};
